import { Directive, ElementRef, inject, OnDestroy } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { Subscription } from 'rxjs';

/**
 * Faz o painel do p-dropdown (appendTo="body") acompanhar a largura do trigger.
 * Uso: <p-dropdown libMatchOverlayWidth appendTo="body" [fluid]="true" />
 */
@Directive({
  selector: 'p-dropdown[libMatchOverlayWidth]',
  standalone: true,
})
export class MatchDropdownOverlayWidthDirective implements OnDestroy {
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly dropdown = inject(Dropdown);
  private readonly sub: Subscription;

  constructor() {
    this.sub = this.dropdown.onShow.subscribe(() => this.matchWidth());
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private matchWidth(): void {
    const width = Math.round(this.el.nativeElement.getBoundingClientRect().width);
    if (!width) {
      return;
    }

    const style = {
      width: `${width}px`,
      minWidth: `${width}px`,
    };

    this.dropdown.panelStyle = {
      ...(this.dropdown.panelStyle || {}),
      ...style,
    };

    requestAnimationFrame(() => {
      const panels = document.querySelectorAll(
        '.p-dropdown-panel, .p-select-overlay'
      );
      const panel = panels[panels.length - 1] as HTMLElement | undefined;
      if (panel) {
        panel.style.width = style.width;
        panel.style.minWidth = style.minWidth;
      }
    });
  }
}
